// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-export-btn {
  border-radius: 5px;
  border: 1px solid var(--Colors-Text-100, #b3b5b4);
  background: #fff;
}

.overview-card {
  .ant-card-head-title {
    font-family: Roboto;
  }
}

.detail-header {
  font-family: Roboto;
}

.campaign-detail-cards {
  width: 100%;
  margin-top: 22px;
}

.detail-label {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.overview-buttons {
  color: var(--Colors-Primary-500, #d2042d) !important;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.amount-card {
  height: 43.5%;

  .ant-card-head {
    display: none;
  }

  .ant-card-body {
    height: 100%;
  }

  .amount-quantity {
    font-family: Roboto;
    color: #000;
    font-size: var(--Font-Font-Size-h3, 20px);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
}

.amount-card .amount-label,
.product-label {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.input-values {
  display: flex;
  flex-direction: column;
}

.amount-content {
  gap: 0.5rem;
  height: 100%;
  display: flex;
  align-items: center;
}

.offer-title {
  display: flex;
  justify-content: space-between;
}

.set-display-content {
  display: flex;
  justify-content: center;
}

.set-display-content {
  display: flex;
  justify-content: center;
}

.pending-amount-card {
  margin-top: 24px;
}

.offer-card {
  height: 94%;
  .offer-header {
    font-size: 19px;
    display: inline;
  }

  .slick-arrow {
    color: #464646;
  }

  .ant-carousel .slick-dots li.slick-active button {
    background: #333 !important;
    height: 6px !important;
    width: 6px !important;
  }

  .ant-carousel .slick-dots li button {
    background: #d9d9d9 !important;
    border: 1px solid #000;
    height: 6px !important;
    width: 6px !important;
  }

  .status-btn,
  .status-btn:hover {
    font-family: Roboto;
    font-size: 13px;
    color: #fff !important;
    font-weight: 500;
    border-radius: 5px;
    background: #dc3545 !important;
    height: 26px;
    padding: 8px;
    right: 42px;
    align-self: center;
    gap: 8px;
    flex-shrink: 0;
    border: none;
  }

  .product-align {
    border-radius: 10px;
    border: 1px solid #cbcbcb;
  }
}

.campaign-product-card {
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  bottom: 15px;
}

.product-header {
  margin: 24px 0;
  font-size: 18px;
}

.product-row {
  flex-flow: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.offer {
  font: 28px;
  font-weight: 800;
  line-height: 24px;
}
.campaign-product-card .image-section {
  align-items: center;
  display: flex;
}
.campaign-product-card .total-price {
  font-family: Roboto;
  color: var(--Colors-Text-300, #5b5e5d);
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.total-price-val {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.88);
  font-weight: 600;
  font-size: 18px;
  line-height: 1.4;
}
.prices {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.mobile-offer-header {
  font-family: Roboto;
  color: #8e9190;
  font-size: 18px;
}

.comments-text {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
}

.card-comments {
  justify-self: center;
  padding: 6px 0 20px 25px;
}

.siteName {
  color: #000;
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.ellipsis-textoverflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
}
.siteNumber {
  color: var(--Colors-Text-200, #8e9190);
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.campaign-more-actions-text {
  font-family: Roboto;
  cursor: pointer;
}

.offer {
  font-family: Roboto;
  font: 28px;
  font-weight: 800;
  line-height: 24px;
}

.campaign-product-card .total-price {
  font-family: Roboto;
  color: var(--Colors-Text-300, #5b5e5d);
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-decoration-line: strikethrough;
}

.prices {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.comments-text {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.card-comments {
  font-family: Roboto;
  margin-top: 29px;
  justify-self: center;
}

.campaign-detail-cards {
  align-items: stretch;
}
.campaign-detail-cards .ant-col {
  font-family: Roboto;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  color: #8e9190;
}
.view-campaigns-details-header {
  margin-top: 10px;
  height: 90px;
}

.campaign-detail-cards .ant-card {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.campaign-detail-cards .ant-card-body {
  padding: 0.5rem 1.2rem;
}
.campaign-detail-cards .campaign-name,
.campaign-id {
  font-family: Roboto;
  display: inline-block;
  max-width: 75%;
  word-wrap: break-word;
}
.campaign-detail-cards .campaign-name,
.campaign-detail-cards .campaign-id {
  font-weight: 500;
  color: #0a0f0d;
  font-size: 14px;
  min-width: 100%;
}
.share-icon {
  width: 18px;
}
.detail-label-image {
  width: 22px !important;
  margin: 0 11px;
}

.chat-btns-image {
  width: 32px;
  height: 28px;
}

.mobile-offer-header-row {
  font-family: Roboto;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.product-align-image {
  width: 90%;
  height: 162px;
  margin-right: 39px;
}

.prices-image {
  width: 22px !important;
  margin: 0 5px;
}

.actions-container-row {
  width: 100%;
  padding: 10px 0;
  column-gap: 15px;
}

.campaign-details-page-row-css {
  width: 100%;
  margin: 0;
  column-gap: 20px;
}

.dates-image {
  width: 11px;
  margin: 0 5px;
  display: inline;
}

.product-label-row {
  margin-left: 10px;
  width: 98%;
}

.view-io-div {
  gap: 1rem;
  display: flex;
}

.view-io-cancel-icon {
  border-radius: 0.3125rem;
  background: #f5f5f5;
  width: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  cursor: pointer;
}

.signature-action {
  width: 60px;
  height: 50px;
  color: #D2042D;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.signature-action svg {
  font-size: 28px;
}

.signature-action span {
  font-size: 11px;
  white-space: nowrap;
}

@media (max-width: 1440px) {
  .amount-quantity {
    font-size: 17px !important;
  }
}

@media (max-width: 1024px) {
  .amount-card {
    height: 43.5%;
  }
  .campaign-detail-cards .detail-cols {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .campaign-detail-cards .campaign-id,
  .campaign-detail-cards .campaign-name {
    display: inline-block;
    max-width: 75%;
    word-wrap: break-word;
  }
  .chat-btns {
    display: flex;
    flex-direction: column;
  }
  .offer-title {
    flex-direction: column;
  }
  .status-btn,
  .status-btn:hover {
    right: 10px !important;
    margin-top: 0.4rem;
  }
}

@media ((max-width: 820px) and (min-width: 767px)) {
  .total-amount-icon {
    width: 100px;
    height: 100px;
  }
}
@media (max-width: 768px) {
  .mobile-campaign-detail-card .campaign-id,
  .product-details .campaign-id {
    color: var(--Colors-Primary-500, #d2042d) !important;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .text-color {
    color: var(--Colors-Primary-500, #d2042d) !important;
  }
  .mobile-campaign-detail-card .campaign-name {
    font-family: Roboto;
    color: #000;
    font-size: var(--Font-Font-Size-p, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .mobile-campaign-detail-card .campaign-values {
    text-align: start;
  }

  .mobile-campaign-detail-card .campaign-inputs {
    margin-top: 24px;
  }
  .mobile-campaign-detail-card .campaign-more-actions-div,
  .actions-container .campaign-amount-container {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .campaign-amount-container {
    padding-left: 0;
  }
  .campaign-overview-total-amount {
    height: 23vw;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    border-radius: 0.625rem;
    background: #fff;
    box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  }
  .campaign-amount-header {
    color: #8e9190;
  }
  .mobile-campaign-button {
    width: 85px;
    height: 96px;
    margin-top: 20px;
    padding: 0 13px 13px 13px;
    align-items: center;

    .ant-card-body {
      padding: 0;
      display: flex;
      justify-content: center;
      text-align: center;
    }

    .share-label {
      padding-top: 12px;
    }

    .actions-container {
      margin-top: 20px;
    }
  }

  .mobile-offer-header {
    font-family: Roboto;
    font-size: 14px;
    color: #000;
    font-style: normal;
    font-weight: 600;
    margin-bottom: 14px;
    margin-left: 1rem;
    line-height: normal;
    margin-left: 39px;
    margin-top: 26px;
  }

  .offers-carousel {
    max-width: 100vw !important;
    height: auto;
    padding-top: 2rem !important;

    .ant-card-body {
      padding-left: 0px !important;
      padding-top: 0px !important;
    }
  }

  .offer-number {
    color: var(--Colors-Primary-500, #d2042d);
    font-size: 13px;
    font-weight: 500;
    padding-bottom: 12px;
    display: inline-block;
  }

  .offer-content {
    margin-left: 1rem;
  }

  .card-comments {
    margin-top: 0px !important;
    text-decoration: underline;
    width: 100%;
    text-align: center;
    display: inline-block;
  }

  .product-details {
    margin-top: 3rem;
  }

  .campaign-product-card {
    width: 100%;
  }

  .product-label {
    padding: 0;
    margin-top: 15px;
  }

  .dates {
    color: #000;
    font-size: 13px;
    font-weight: 500;
    width: 90%;
    display: inline-block;
  }

  .product-align {
    display: flex;
    padding-left: 0;
  }

  .offer-group {
    display: flex;
  }

  .offer-label {
    margin-left: 10px;
  }

  .mobile-offer-card {
    .slick-arrow {
      margin-top: 15px;
    }
  }

  .offer-price {
    font-family: Roboto;
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h4, 28px);
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    margin-top: 10px;
  }

  .total-price-group {
    margin-top: 11px;
  }

  .total-price {
    font-family: Roboto;
    margin-left: 5px;
  }

  .offer-title {
    flex-direction: row;
  }

  .offer-card .status-btn,
  .status-btn:hover {
    right: 20px !important;
  }
  .detail-header {
    font-family: Roboto;
    position: relative;
    margin-bottom: 2rem;
    font-size: 16px;
  }
  .mobile-campaign-detail-card .campaign-name {
    color: var(--Colors-Text-500, #0a0f0d) !important;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }

  .billboard-values {
    font-family: Roboto;
    font-size: 14px !important;
    font-weight: 600;
  }
  .terms-section {
    display: flex;
    align-items: center;
  }
  .actions-container-row {
    width: 85vw;
    overflow-x: auto;
  }
}
@media (max-width: 768px) {
  .billboard-values {
    font-family: Roboto;
    font-size: 14px !important;
    font-weight: 600;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/SellerFlow/dashboard/campaign-detailpage/CampaignDetailPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;;EAEb;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;;EAEE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;EACA;;IAEE,qBAAqB;IACrB,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;AACA;EACE;;IAEE,oDAAoD;IACpD,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;EACA;;IAEE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;IAChB,kDAAkD;EACpD;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;;IAEnB;MACE,UAAU;MACV,aAAa;MACb,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,YAAY;IACZ,4BAA4B;;IAE5B;MACE,4BAA4B;MAC5B,2BAA2B;IAC7B;EACF;;EAEA;IACE,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,mBAAmB;IACnB,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,iDAAiD;IACjD,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;EAClB;AACF","sourcesContent":[".campaign-export-btn {\n  border-radius: 5px;\n  border: 1px solid var(--Colors-Text-100, #b3b5b4);\n  background: #fff;\n}\n\n.overview-card {\n  .ant-card-head-title {\n    font-family: Roboto;\n  }\n}\n\n.detail-header {\n  font-family: Roboto;\n}\n\n.campaign-detail-cards {\n  width: 100%;\n  margin-top: 22px;\n}\n\n.detail-label {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.overview-buttons {\n  color: var(--Colors-Primary-500, #d2042d) !important;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.amount-card {\n  height: 43.5%;\n\n  .ant-card-head {\n    display: none;\n  }\n\n  .ant-card-body {\n    height: 100%;\n  }\n\n  .amount-quantity {\n    font-family: Roboto;\n    color: #000;\n    font-size: var(--Font-Font-Size-h3, 20px);\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n}\n\n.amount-card .amount-label,\n.product-label {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.input-values {\n  display: flex;\n  flex-direction: column;\n}\n\n.amount-content {\n  gap: 0.5rem;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.offer-title {\n  display: flex;\n  justify-content: space-between;\n}\n\n.set-display-content {\n  display: flex;\n  justify-content: center;\n}\n\n.set-display-content {\n  display: flex;\n  justify-content: center;\n}\n\n.pending-amount-card {\n  margin-top: 24px;\n}\n\n.offer-card {\n  height: 94%;\n  .offer-header {\n    font-size: 19px;\n    display: inline;\n  }\n\n  .slick-arrow {\n    color: #464646;\n  }\n\n  .ant-carousel .slick-dots li.slick-active button {\n    background: #333 !important;\n    height: 6px !important;\n    width: 6px !important;\n  }\n\n  .ant-carousel .slick-dots li button {\n    background: #d9d9d9 !important;\n    border: 1px solid #000;\n    height: 6px !important;\n    width: 6px !important;\n  }\n\n  .status-btn,\n  .status-btn:hover {\n    font-family: Roboto;\n    font-size: 13px;\n    color: #fff !important;\n    font-weight: 500;\n    border-radius: 5px;\n    background: #dc3545 !important;\n    height: 26px;\n    padding: 8px;\n    right: 42px;\n    align-self: center;\n    gap: 8px;\n    flex-shrink: 0;\n    border: none;\n  }\n\n  .product-align {\n    border-radius: 10px;\n    border: 1px solid #cbcbcb;\n  }\n}\n\n.campaign-product-card {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  bottom: 15px;\n}\n\n.product-header {\n  margin: 24px 0;\n  font-size: 18px;\n}\n\n.product-row {\n  flex-flow: nowrap;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.offer {\n  font: 28px;\n  font-weight: 800;\n  line-height: 24px;\n}\n.campaign-product-card .image-section {\n  align-items: center;\n  display: flex;\n}\n.campaign-product-card .total-price {\n  font-family: Roboto;\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.total-price-val {\n  margin-bottom: 0.5em;\n  color: rgba(0, 0, 0, 0.88);\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 1.4;\n}\n.prices {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.mobile-offer-header {\n  font-family: Roboto;\n  color: #8e9190;\n  font-size: 18px;\n}\n\n.comments-text {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  cursor: pointer;\n}\n\n.card-comments {\n  justify-self: center;\n  padding: 6px 0 20px 25px;\n}\n\n.siteName {\n  color: #000;\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.ellipsis-textoverflow {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 90%;\n}\n.siteNumber {\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.campaign-more-actions-text {\n  font-family: Roboto;\n  cursor: pointer;\n}\n\n.offer {\n  font-family: Roboto;\n  font: 28px;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.campaign-product-card .total-price {\n  font-family: Roboto;\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  text-decoration-line: strikethrough;\n}\n\n.prices {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.comments-text {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n\n.card-comments {\n  font-family: Roboto;\n  margin-top: 29px;\n  justify-self: center;\n}\n\n.campaign-detail-cards {\n  align-items: stretch;\n}\n.campaign-detail-cards .ant-col {\n  font-family: Roboto;\n  font-size: 16px;\n  display: flex;\n  flex-direction: column;\n  color: #8e9190;\n}\n.view-campaigns-details-header {\n  margin-top: 10px;\n  height: 90px;\n}\n\n.campaign-detail-cards .ant-card {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n.campaign-detail-cards .ant-card-body {\n  padding: 0.5rem 1.2rem;\n}\n.campaign-detail-cards .campaign-name,\n.campaign-id {\n  font-family: Roboto;\n  display: inline-block;\n  max-width: 75%;\n  word-wrap: break-word;\n}\n.campaign-detail-cards .campaign-name,\n.campaign-detail-cards .campaign-id {\n  font-weight: 500;\n  color: #0a0f0d;\n  font-size: 14px;\n  min-width: 100%;\n}\n.share-icon {\n  width: 18px;\n}\n.detail-label-image {\n  width: 22px !important;\n  margin: 0 11px;\n}\n\n.chat-btns-image {\n  width: 32px;\n  height: 28px;\n}\n\n.mobile-offer-header-row {\n  font-family: Roboto;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.product-align-image {\n  width: 90%;\n  height: 162px;\n  margin-right: 39px;\n}\n\n.prices-image {\n  width: 22px !important;\n  margin: 0 5px;\n}\n\n.actions-container-row {\n  width: 100%;\n  padding: 10px 0;\n  column-gap: 15px;\n}\n\n.campaign-details-page-row-css {\n  width: 100%;\n  margin: 0;\n  column-gap: 20px;\n}\n\n.dates-image {\n  width: 11px;\n  margin: 0 5px;\n  display: inline;\n}\n\n.product-label-row {\n  margin-left: 10px;\n  width: 98%;\n}\n\n.view-io-div {\n  gap: 1rem;\n  display: flex;\n}\n\n.view-io-cancel-icon {\n  border-radius: 0.3125rem;\n  background: #f5f5f5;\n  width: 2.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 2.5rem;\n  cursor: pointer;\n}\n\n.signature-action {\n  width: 60px;\n  height: 50px;\n  color: #D2042D;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.signature-action svg {\n  font-size: 28px;\n}\n\n.signature-action span {\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n@media (max-width: 1440px) {\n  .amount-quantity {\n    font-size: 17px !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .amount-card {\n    height: 43.5%;\n  }\n  .campaign-detail-cards .detail-cols {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n  .campaign-detail-cards .campaign-id,\n  .campaign-detail-cards .campaign-name {\n    display: inline-block;\n    max-width: 75%;\n    word-wrap: break-word;\n  }\n  .chat-btns {\n    display: flex;\n    flex-direction: column;\n  }\n  .offer-title {\n    flex-direction: column;\n  }\n  .status-btn,\n  .status-btn:hover {\n    right: 10px !important;\n    margin-top: 0.4rem;\n  }\n}\n\n@media ((max-width: 820px) and (min-width: 767px)) {\n  .total-amount-icon {\n    width: 100px;\n    height: 100px;\n  }\n}\n@media (max-width: 768px) {\n  .mobile-campaign-detail-card .campaign-id,\n  .product-details .campaign-id {\n    color: var(--Colors-Primary-500, #d2042d) !important;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .text-color {\n    color: var(--Colors-Primary-500, #d2042d) !important;\n  }\n  .mobile-campaign-detail-card .campaign-name {\n    font-family: Roboto;\n    color: #000;\n    font-size: var(--Font-Font-Size-p, 16px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .mobile-campaign-detail-card .campaign-values {\n    text-align: start;\n  }\n\n  .mobile-campaign-detail-card .campaign-inputs {\n    margin-top: 24px;\n  }\n  .mobile-campaign-detail-card .campaign-more-actions-div,\n  .actions-container .campaign-amount-container {\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n  .campaign-amount-container {\n    padding-left: 0;\n  }\n  .campaign-overview-total-amount {\n    height: 23vw;\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    border-radius: 0.625rem;\n    background: #fff;\n    box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  }\n  .campaign-amount-header {\n    color: #8e9190;\n  }\n  .mobile-campaign-button {\n    width: 85px;\n    height: 96px;\n    margin-top: 20px;\n    padding: 0 13px 13px 13px;\n    align-items: center;\n\n    .ant-card-body {\n      padding: 0;\n      display: flex;\n      justify-content: center;\n      text-align: center;\n    }\n\n    .share-label {\n      padding-top: 12px;\n    }\n\n    .actions-container {\n      margin-top: 20px;\n    }\n  }\n\n  .mobile-offer-header {\n    font-family: Roboto;\n    font-size: 14px;\n    color: #000;\n    font-style: normal;\n    font-weight: 600;\n    margin-bottom: 14px;\n    margin-left: 1rem;\n    line-height: normal;\n    margin-left: 39px;\n    margin-top: 26px;\n  }\n\n  .offers-carousel {\n    max-width: 100vw !important;\n    height: auto;\n    padding-top: 2rem !important;\n\n    .ant-card-body {\n      padding-left: 0px !important;\n      padding-top: 0px !important;\n    }\n  }\n\n  .offer-number {\n    color: var(--Colors-Primary-500, #d2042d);\n    font-size: 13px;\n    font-weight: 500;\n    padding-bottom: 12px;\n    display: inline-block;\n  }\n\n  .offer-content {\n    margin-left: 1rem;\n  }\n\n  .card-comments {\n    margin-top: 0px !important;\n    text-decoration: underline;\n    width: 100%;\n    text-align: center;\n    display: inline-block;\n  }\n\n  .product-details {\n    margin-top: 3rem;\n  }\n\n  .campaign-product-card {\n    width: 100%;\n  }\n\n  .product-label {\n    padding: 0;\n    margin-top: 15px;\n  }\n\n  .dates {\n    color: #000;\n    font-size: 13px;\n    font-weight: 500;\n    width: 90%;\n    display: inline-block;\n  }\n\n  .product-align {\n    display: flex;\n    padding-left: 0;\n  }\n\n  .offer-group {\n    display: flex;\n  }\n\n  .offer-label {\n    margin-left: 10px;\n  }\n\n  .mobile-offer-card {\n    .slick-arrow {\n      margin-top: 15px;\n    }\n  }\n\n  .offer-price {\n    font-family: Roboto;\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h4, 28px);\n    font-style: normal;\n    font-weight: 800;\n    line-height: 24px;\n    margin-top: 10px;\n  }\n\n  .total-price-group {\n    margin-top: 11px;\n  }\n\n  .total-price {\n    font-family: Roboto;\n    margin-left: 5px;\n  }\n\n  .offer-title {\n    flex-direction: row;\n  }\n\n  .offer-card .status-btn,\n  .status-btn:hover {\n    right: 20px !important;\n  }\n  .detail-header {\n    font-family: Roboto;\n    position: relative;\n    margin-bottom: 2rem;\n    font-size: 16px;\n  }\n  .mobile-campaign-detail-card .campaign-name {\n    color: var(--Colors-Text-500, #0a0f0d) !important;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n  }\n\n  .billboard-values {\n    font-family: Roboto;\n    font-size: 14px !important;\n    font-weight: 600;\n  }\n  .terms-section {\n    display: flex;\n    align-items: center;\n  }\n  .actions-container-row {\n    width: 85vw;\n    overflow-x: auto;\n  }\n}\n@media (max-width: 768px) {\n  .billboard-values {\n    font-family: Roboto;\n    font-size: 14px !important;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
